import { Link } from 'react-router-dom';

interface StudentLinkProps {
  label: string;
  uuid: string;
  target?: string;
}

export default function StudentLink({
  uuid,
  label,
  target = '_blank',
}: StudentLinkProps) {
  return (
    <Link to={`/students/${uuid}`} target={target}>
      {label}
    </Link>
  );
}
